module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_3a-646aaa062b056d106c2a6db32f82a411.jpg";